

export const link_getLinkType = (url:string) => {
    let link = new URL(url)
    switch(link.host){
        case 'youtu.be':
            return 'youtube'
        case 'youtube':
            return 'youtube'
        default: 
            return 'preview'
    }
}


export const link_getYoutubeEmbedId = (url:string) => {
    let link = new URL(url)
    if(link.host !== 'youtu.be'){ return '' }
    let parsed_path = link.pathname.split('/')
    return parsed_path[1]
}